import { createAction } from 'typesafe-actions';
import { TransactionMatchPayload, TransactionMatchResponse, TransactionAutoMatchPayload, TransactionAutoMatchResponse } from 'types/dto';
import { TransactionMatchResult, TransactionAutoMatchResult } from 'types/store';

export enum TransactionHandleAction {
  Error = 'TRANSACTION_HANDLE_ERROR',
  MatchRequest = 'TRANSACTION_MATCH_REQUEST',
  MatchResponse = 'TRANSACTION_MATCH_RESPONSE',
  MatchResult = 'TRANSACTION_MATCH_RESULT',
  UnmatchRequest = 'TRANSACTION_UNMATCH_REQUEST',
  UnmatchResponse = 'TRANSACTION_UNMATCH_RESPONSE',
  AutoMatchRequest = 'TRANSACTION_AUTOMATCH_REQUEST',
  AutoMatchResponse = 'TRANSACTION_AUTOMATCH_RESPONSE',
  AutoMatchResult = 'TRANSACTION_AUTOMATCH_RESULT',
}

export const transactionHandleError = createAction(TransactionHandleAction.Error)<Error>();

export const transactionMatchRequest = createAction(
  TransactionHandleAction.MatchRequest,
)<TransactionMatchPayload>();
export const transactionMatchResponse = createAction(
  TransactionHandleAction.MatchResponse,
)<TransactionMatchResponse>();
export const transactionMatchResult = createAction(
  TransactionHandleAction.MatchResult,
)<TransactionMatchResult>();
export const transactionAutoMatchRequest = createAction(
    TransactionHandleAction.AutoMatchRequest,
)<TransactionAutoMatchPayload>();
export const transactionAutoMatchResponse = createAction(
    TransactionHandleAction.AutoMatchResponse,
)<TransactionAutoMatchResponse>();
export const transactionAutoMatchResult = createAction(
    TransactionHandleAction.AutoMatchResult,
)<TransactionAutoMatchResult>();


export const transactionUnmatchRequest = createAction(TransactionHandleAction.UnmatchRequest)<
  Array<string>
>();
export const transactionUnmatchResponse = createAction(TransactionHandleAction.UnmatchResponse)<
  Array<string>
>();

export * from './bank/actions';
export * from './system/actions';
